import { createSelector } from 'reselect';


const healthcheck = (store) => store.apps.healthCheck;

const containerSelector = createSelector([
  healthcheck,
],
(filteredState) => ({
  encore: filteredState.backend.get('encore'),
  resto: filteredState.backend.get('resto'),
  userService: filteredState.backend.get('userService'),
}));


export default containerSelector;
export {
  containerSelector,
  healthcheck,
};
